import classNames from "classnames";
import Styles from "./Text.module.scss";
const SubTitle = ({ text }) => {
  return (
    <div className={classNames("container", Styles.title)}>
      <p>{text}</p>
    </div>
  );
};
export default SubTitle;